module.exports = __webpack_public_path__ + "static/media/logo_medium.c3daa47b.png";